import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { formatRelativeTime } from '@helpers/formatRelativeTime'
import './NotificationItem.css'

interface NotificationItemProps {
  title: string
  subtitle?: string
  datetime: string
  description: string
  icon: React.ComponentType<{ size?: number; color?: string }>
  isRead: boolean
  color: string
  onRead?: () => void
}

const NotificationItem: React.FC<NotificationItemProps> = ({ title, subtitle, datetime, description, icon: IconComponent, isRead, color, onRead }) => {
  const handleClick = () => {
    if (!isRead && onRead) {
      onRead()
    }
    window.open('/pedidos', '_blank')
  }

  const wrapperClassName = `notification-item-wrapper${!isRead ? ' notification-item--unread' : ''}`

  return (
    <Dropdown.Item
      as="div"
      className={wrapperClassName}
      onClick={handleClick}
      style={{ '--notif-color': color } as React.CSSProperties}
    >
      <div className="d-flex align-items-start px-2" style={{ padding: '10px 8px' }}>
        <div
          style={{
            minWidth: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: `${color}12`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '10px',
            marginTop: '2px',
            flexShrink: 0
          }}
        >
          <IconComponent size={15} color={color} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="d-flex align-items-center justify-content-between" style={{ gap: '6px', marginBottom: '1px' }}>
            <span className="notification-item-title" style={{ fontWeight: '600', fontSize: '13px', color: '#2c3e50', lineHeight: '1.4' }}>
              {subtitle}
            </span>
            <div className="d-flex align-items-center" style={{ gap: '8px', flexShrink: 0 }}>
              {!isRead && (
                <div
                  style={{
                    width: '7px',
                    height: '7px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    flexShrink: 0
                  }}
                />
              )}
              <span style={{ fontSize: '11px', color: '#adb5bd', whiteSpace: 'nowrap' }}>
                {formatRelativeTime(datetime)}
              </span>
            </div>
          </div>
          <div style={{ marginBottom: '2px' }}>
            <span style={{ fontSize: '11px', color: '#95a5a6' }}>
              Pedido {title}
            </span>
          </div>
          <div className="notification-description" style={{ fontSize: '12px', color: '#6c757d', lineHeight: '1.4' }} dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    </Dropdown.Item>
  )
}

export default NotificationItem
